import "@/App.css";
import "lenis/dist/lenis.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MarqueeStrip from "@/components/MarqueeStrip";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import StatsBand from "@/components/StatsBand";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";

function App() {
    return (
        <ReactLenis root options={{ lerp: 0.08, duration: 1.2 }}>
            <div className="min-h-screen bg-background text-ink font-sans relative">
                <div className="noise-overlay" aria-hidden="true" />
                <Navbar />
                <main>
                    <Hero />
                    <MarqueeStrip />
                    <Services />
                    <Manifesto />
                    <StatsBand />
                    <About />
                    <Testimonials />
                    <ContactForm />
                </main>
                <Footer />
                <Toaster position="bottom-right" />
            </div>
        </ReactLenis>
    );
}

export default App;
